class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.pageCount = this.querySelector('[id^="SlideCount-"]');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));

    this.setSlideVisibility();
  }

  setSlideVisibility() {
    this.sliderItems.forEach((item) => {
      const rect = item.getBoundingClientRect();
      if (
        rect.left >= this.slider.getBoundingClientRect().left &&
        rect.right <= this.slider.getBoundingClientRect().right
      ) {
        item.classList.add('is-visible');
      } else {
        item.classList.remove('is-visible');
      }
    });
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = this.sliderItems[0].offsetWidth;
    if (event.currentTarget === this.nextButton) {
      this.slider.scrollBy({ left: step, behavior: 'smooth' });
    } else {
      this.slider.scrollBy({ left: -step, behavior: 'smooth' });
    }
  }

  update() {
    if (this.pageCount) {
      const visibleSlides = [...this.sliderItems].filter((item) =>
        item.classList.contains('is-visible')
      );
      const firstVisible = this.sliderItems.indexOf(visibleSlides[0]) + 1;
      const lastVisible =
        this.sliderItems.indexOf(visibleSlides[visibleSlides.length - 1]) + 1;
      this.pageCount.textContent =
        firstVisible === lastVisible
          ? `${firstVisible} / ${this.sliderItems.length}`
          : `${firstVisible}-${lastVisible} / ${this.sliderItems.length}`;
    }
  }

  isSlideVisible(slide, offset = 0) {
    const rect = slide.getBoundingClientRect();
    const sliderRect = this.slider.getBoundingClientRect();
    return (
      rect.left >= sliderRect.left - offset &&
      rect.right <= sliderRect.right + offset
    );
  }
}

customElements.define('slider-component', SliderComponent);
